import PlatformCustomizationContainer from './components/PlatformCustomizationContainer';

export default PlatformCustomizationContainer;
